// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2B40j","inputDescription":"styles_inputDescription__2HTQ5"};